<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off">
                            <input type="text" placeholder="search" (keyup.enter)="getServiceProviderByWildSearch()"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                        </form>
                        <i class="bi bi-search" (click)="getServiceProviderByWildSearch()"></i>
                    </div>
                    <button title="Add" data-toggle="modal" data-target="#addModal">
                        <i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}
                    </button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 15%;">{{ 'serviceProviders.id' | translate }}</th>
                        <th style="width: 25%;">{{ 'serviceProviders.name' | translate }}</th>
                        <th style="width: 20%;">{{ 'serviceProviders.zone' | translate }}</th>
                        <th style="width: 25%;">{{ 'serviceProviders.contact' | translate }}</th>
                        <th style="width: 15%; text-align: center; padding: 0;">{{ 'generic.action' | translate }}</th>
                    </tr>
                </thead>
            </table>

            <div *ngIf="!isLoading">
                <div class="data-view" id="{{provider.id}}"
                    [ngClass]="{ 'delete-highlight': provider.serviceProvidersId == recordId }" *ngFor="let provider of serviceProvidersList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }; let i = index">

                    <p style="width: 15%;">{{provider.serviceProvidersId || " -- " }}</p>
                    <p style="width: 25%;">{{provider.serviceProviderName || " -- " }}</p>
                    <p style="width: 20%;">{{provider.serviceProviderOperatingZone || " -- " }}</p>
                    <p style="width: 25%;">{{provider.serviceProviderContactDetails || " -- " }}</p>

                    <p class="action-buttons" style="width: 15%; padding-left: 25px;">
                        <i title="Edit" class="bi bi-pencil-square"
                            (click)="getServiceProviderById(provider.serviceProvidersId)" data-toggle="modal"
                            data-target="#editModal"></i>
                        <i title="Delete" class="bi bi-trash3" (click)="deleteIdSelect(provider.id, provider)"
                            data-toggle="modal" data-target="#deleteModal"></i>
                    </p>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && serviceProvidersList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>

        </div>
    </div>
</div>

<!-- Deletion Confirmation Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteServiceProvider()" class="btn btn-primary"
                        [disabled]="isActionLoading">
                        <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                        {{ 'generic.delete' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add Modal -->
<div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="addModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addModalLabel">{{ 'serviceProviders.headings.add' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="serviceProviderForm">
                    <div class="form-group">
                        <label>{{ 'serviceProviders.name' | translate }} <span class="required">*</span></label>
                        <input formControlName="serviceProviderName" type="text" class="form-control">
                        <span class="err"
                            *ngIf="serviceProviderForm.get('serviceProviderName')?.invalid && formSubmit">Name
                            required</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'serviceProviders.zone' | translate }}</label>
                        <select formControlName="serviceProviderOperatingZone" class="form-control">
                            <option value="" selected disabled> -- select location --</option>
                            <option value="{{loc.zone}}" *ngFor="let loc of locationFilterList">{{loc.zone}} -
                                {{loc.city}} - {{loc.postalCode}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>{{ 'serviceProviders.contact' | translate }}</label>
                        <input formControlName="serviceProviderContactDetails" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'generic.description' | translate }}</label>
                        <textarea formControlName="description" class="form-control" rows="3"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="addServiceProvider()" class="btn btn-primary"
                        [disabled]="isActionLoading">
                        <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                        {{ 'generic.add' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="editModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">{{ 'serviceProviders.headings.edit' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="serviceProviderUpdateForm">
                    <div class="form-group">
                        <label>{{ 'serviceProviders.name' | translate }} <span class="required">*</span></label>
                        <input formControlName="serviceProviderName" type="text" class="form-control">
                        <span class="err"
                            *ngIf="serviceProviderUpdateForm.get('serviceProviderName')?.invalid && formSubmit">Name
                            required</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'serviceProviders.zone' | translate }}</label>
                        <select formControlName="serviceProviderOperatingZone" class="form-control">
                            <option value="" selected disabled> -- select location --</option>
                            <option value="{{loc.zone}}" *ngFor="let loc of locationFilterList">{{loc.zone}} -
                                {{loc.city}} - {{loc.postalCode}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>{{ 'serviceProviders.contact' | translate }}</label>
                        <input formControlName="serviceProviderContactDetails" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'generic.description' | translate }}</label>
                        <textarea formControlName="description" class="form-control" rows="3"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateServiceProvider()" class="btn btn-primary"
                        [disabled]="isActionLoading">
                        <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                        {{ 'generic.update' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>